var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'rounded-image ' + _vm.kind},[_c('img',{staticClass:"round",attrs:{"src":_vm.src,"alt":"image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }